/**
 * This module wraps global environment variables declared when compiling.
 * Consumers of these variables can now import this module rather than declaring globals.
 */
declare const LUMINOPIA_API_URL: string
declare const LUMINOPIA_CONTENT_API_URL: string
declare const LUMINOPIA_ADHERENCE_API_URL: string
declare const LUMINOPIA_WEB_URL: string
declare const VERSION: string
declare const RELEASE_ENVIRONMENT: string
declare const MONITORING_PORTAL_KEY: string

declare const SENTRY_DSN: string | undefined

export const API_URL = LUMINOPIA_API_URL
export const ADHERENCE_API_URL = LUMINOPIA_ADHERENCE_API_URL
export const CONTENT_API_URL = LUMINOPIA_CONTENT_API_URL
export const WEB_URL = LUMINOPIA_WEB_URL
export const RAVEN_CONFIG_DSN = SENTRY_DSN
/** The release environment of the app, typically: development | staging | production */
export const ENVIRONMENT = RELEASE_ENVIRONMENT
export const APP_VERSION = VERSION
export const PORTAL_KEY = MONITORING_PORTAL_KEY



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/env.ts